import { observable } from 'mobx';

export type RailwayPackageLimitTypeJson = {
  id?: number;
  business_days?: number;
  hour?: number;
};

class RailwayPackageLimitType {
  @observable
  readonly id?: number | null;

  @observable
  businessDays: number;

  @observable
  hour: number;

  constructor(args: RailwayPackageLimitTypeJson) {
    this.id = args.id;
    this.businessDays = args.business_days ? args.business_days : 3;
    this.hour = args.hour ? args.hour : 18;
  }

  description() {
    return `${this.businessDays}営${this.hour}時`;
  }

  submitParams() {
    return {
      id: this.id,
      business_days: this.businessDays,
      hour: this.hour
    };
  }
}

export default RailwayPackageLimitType;
